// Body de mensagem `mediaType = "template"` no painel segue a convencao de
// templates.js: "<url da midia> \n <texto>||||<JSON dos botoes>". Na citacao
// (resposta a um template) so o texto interessa.
const URL_MIDIA = /(https?:\/\/[^\s]+(\.jpg|\.jpeg|\.png|\.gif|\.mp4|\.webm|\.ogg))/g;

export function resumoCitacaoTemplate(body) {
  if (!body) return "";
  const [texto] = String(body).split("||||");
  return texto.replace(URL_MIDIA, "").trim();
}
